export default __webpack_public_path__ + "static/media/82.ecca6807.png";